// extracted by mini-css-extract-plugin
export default {"item":"XbS9VZTyCnUEec5MII_B","placeHolderShimmer":"bykIyoeCxMLRB0HQeZn5"};